module.exports = __webpack_public_path__ + "static/wvwalkthroughview-optimize.90a2f265.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/wvwalkthroughview-optimize.gif
// module id = 483
// module chunks = 35783957827783